import getAxiosInstance from '../../helpers/get_axios_instance'
import lrsAdapter from '../../helpers/lrs_adapter'

class PesoBruto {
  static altaPesado (brutoValues = {}) {
    const {
      numero,
      balanza,
      balancero,
      pesoBruto,
      calleVolcadora
    } = brutoValues
    const axios = getAxiosInstance()

    const promise = axios.post(`carga_entrante_automotor_con_bruto`,
      `{"valores": {"carta_de_porte_automotor": "${numero}", 
      "balanza_de_bruto": "${balanza}", "peso_bruto": "${pesoBruto}", 
      "balancero_de_bruto": "${balancero}", "calle_de_volcadora": "${calleVolcadora}" }}`)
    return promise.then(lrsAdapter, lrsAdapter)
      .then((result) => { return result })
  }

  static repesado (brutoValues = {}) {
    const {
      numero,
      pesoBruto,
      balanza,
      calleVolcadora
    } = brutoValues
    const axios = getAxiosInstance()
    const promise = axios.put(`carga_entrante_automotor_con_bruto`,
      `{"valores": {"balanza_de_bruto": "${balanza}", "peso_bruto": "${pesoBruto}", "calle_de_volcadora": "${calleVolcadora}"}, 
      "clave": {"carta_de_porte_automotor": "${numero}"}}`)
    return promise.then(lrsAdapter, lrsAdapter)
      .then((result) => { return result.data[0] })
  }

  // separar del update
  // static updateCalleDeVolcadora (numero, calleDeVolcadora) {
  //   const axios = getAxiosInstance()
  //   const promise = axios.put(`carga_entrante_automotor_con_bruto`,
  //     `{"valores": {"calle_de_volcadora": "${calleDeVolcadora}"}, "clave": {"carta_de_porte_automotor": "${numero}"}}`)
  //   return promise
  //     .then(lrsAdapter, lrsAdapter)
  //     .then((result) => { return result.data[0] })
  // }

  static getUltimoPesado () {
    const axios = getAxiosInstance()
    const promise = axios.get(`consulta_cea_con_peso_listado?r=` +
      `{"limite":1, "orden": ["d:fecha_de_bruto"]}`)
    return promise.then(lrsAdapter, lrsAdapter)
      .then((result) => {
        return result.data[0]
      })
  }

  static setBalanzaBruto (balanza) {
    const axios = getAxiosInstance()
    const promise = axios.get(`cambiar_balanza_bruto?r=` +
      `{"parametros": {"balanza": "${balanza}"}}`)
    return promise.then(lrsAdapter, lrsAdapter)
      .then((result) => {
        return result.data[0]
      })
  }

  static getFotoCeaEnBruto (numero) {
    const axios = getAxiosInstance()
    const orden = '"orden": ["d:fecha_de_ingreso"]'
    const promise = axios.get(`foto_cpa_bruto?r=` +
      `{"clave":{"nro_ctge": "${numero}"}, ${orden}}`)
    return promise.then(lrsAdapter, lrsAdapter)
      .then((data) => { return data.data[0] })
      .catch(lrsAdapter)
  }
}

export default PesoBruto
